export var Status;
(function (Status) {
    Status["PENDING"] = "pending";
    Status["COMPLETE"] = "complete";
    Status["FAILED"] = "failed";
})(Status || (Status = {}));
export var PendingHintCode;
(function (PendingHintCode) {
    PendingHintCode["OUTSTANDINGTRANSACTION"] = "outstandingTransaction";
    PendingHintCode["NOCLIENT"] = "noClient";
    PendingHintCode["STARTED"] = "started";
    PendingHintCode["USERSIGN"] = "userSign";
})(PendingHintCode || (PendingHintCode = {}));
export var FailedHintCode;
(function (FailedHintCode) {
    FailedHintCode["EXPIREDTRANSACTION"] = "expiredTransaction";
    FailedHintCode["CERTIFICATEERR"] = "certificateErr";
    FailedHintCode["USERCANCEL"] = "userCancel";
    FailedHintCode["CANCELLED"] = "cancelled";
    FailedHintCode["STARTFAILED"] = "startFailed";
    FailedHintCode["UNKNOWN"] = "unknown";
})(FailedHintCode || (FailedHintCode = {}));
